import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import ProjectEditor from '@/routes/projects/ProjectEditor'
import { projectEditorRouteAction, projectEditorRouteLoader } from '@/routes/projects/ProjectEditor.route'
import { RoleRouteObject } from '@/types'

const ProjectCreatorRoute = {
  path: 'new',
  element: <ProjectEditor creating={true} />,
  loader: projectEditorRouteLoader,
  action: projectEditorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default ProjectCreatorRoute
